export const COMPONENT = {
  HIERARCHICAL_QUERY: 'hierarchical-query',
} as const;
